/**
 * DeleteConfirmDialog Component
 *
 * Confirmation dialog for topic deletion.
 * Displays topic name and asks user to confirm the deletion action.
 */

import { IDeleteConfirmDialogProps } from '../../@types/topics';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../ui/dialog';
import { Button } from '../ui/button';

const DeleteConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  topicName,
}: IDeleteConfirmDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Delete Topic?</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete this topic? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>

        {topicName && (
          <div className="p-4 bg-muted rounded-md">
            <p className="font-medium">{topicName}</p>
          </div>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            Delete Topic
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export { DeleteConfirmDialog };
